import { Market, Status } from 'data/countryAttributes/types/Market';

export const DEFAULT_MARKET = 'us';

const MARKET_MATCHER = /^\/(int|[a-z]{2}|[a-z]{2}-[a-z]{2})(\/|$)/;

export const isMarketPresent = (path = ''): boolean => {
  const locationMarket = path.match(MARKET_MATCHER);
  return Boolean(locationMarket && locationMarket.length > 1 && locationMarket[1]);
};

// Happily borrowed from www-account-pages
export const extractMarket = (path = '') => {
  const locationMarket = path.match(MARKET_MATCHER);
  const market = locationMarket && locationMarket.length > 1 && locationMarket[1];
  return market || DEFAULT_MARKET;
};

export const isMarketLaunched = (market: Market): boolean =>
  market.market !== 'int' && market.status !== Status.IN_SYSTEM;

const ENGLISH_SUPPORT_ONLY_LOCALES = ['fi-FI', 'hu-HU', 'he-IL', 'da-DK', 'el-GR', 'nb-NO', 'pt-PT', 'uk-UA', 'hi-IN'];

export const isEnglishSupportOnlyLocale = (locale: string) => {
  // locale be like `da-DK`(${language}-${country})
  if (!locale) return true;

  return ENGLISH_SUPPORT_ONLY_LOCALES.includes(locale);
};
